import script from "./MProfilePremium.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfilePremium.vue?vue&type=script&setup=true&lang=js"

import "./MProfilePremium.vue?vue&type=style&index=0&id=048246e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048246e8"]])

export default __exports__